import { type FunctionComponent, type ReactNode } from 'react'
import { useFastFind } from '../utils/hooks/useFastFind'

const FastFindProvider: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  useFastFind()
  return <>{children}</>
}

export default FastFindProvider
